module["exports"] = [
  "/3528-####-####-###L/",
  "/3529-####-####-###L/",
  "/35[3-8]#-####-####-###L/"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en/credit_card/jcb.js
 ** module id = 304
 ** module chunks = 0
 **/